import React from "react";
import NumberFormat from "react-number-format";
import { formatDate } from "../../utils/utils";
import Show from "../../utils/show.component";

const PaymentBreakdown = (props) => (
  <div className="payment-breakdown">
    {/* Payment applied date */}
    <Show condition={props.paymentType !== "Appraisal"}>
      <p>
        <strong className="highlight" id="payment-applied-date">
          Payment will be applied{" "}
          {/* check for the chargeoff flag in both spans so we dont show both disclaimers */}
          <span className={props.ChargeOffIsRequired || props.ConvenienceFee != "0" ? "hide" : ""}>
            on or before{" "}
          </span>
          <span className={props.ChargeOffIsRequired ? "" : "hide"}>on or after </span>
          {formatDate(props.PostDate)}
        </strong>
      </p>
    </Show>
    <div className={props.paymentType !== "Appraisal" ? "payment-breakdown payment-row" : "payment-row"}>
      <div className="payment-line-item">
        <div className="label">Payment Amount</div>
        <strong id="payment-amount">
          <NumberFormat
            fixedDecimalScale={true}
            decimalScale={2}
            value={props.PaymentAmount}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
          />
        </strong>
      </div>
      <Show condition={props.ConvenienceFee !== undefined}>
        <div className={props.ConvenienceFee != "0" ? "payment-line-item" : "hide"}>
          <div className="label">Convenience Fee</div>
          <strong>${props.ConvenienceFee}</strong>
        </div>
      </Show>
    </div>
    <div className="total-payment-amount">
      <div className="label">
        <strong>Total Payment</strong>
      </div>
      <div className="total-amount">
        <NumberFormat
          fixedDecimalScale={true}
          decimalScale={2}
          value={parseFloat(props.PaymentAmount) + parseFloat(props.ConvenienceFee)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />
      </div>
    </div>
  </div>
);

export default PaymentBreakdown;



// WEBPACK FOOTER //
// ./src/components/payment-breakdown/payment-breakdown.component.js